import { useState, useEffect } from "react";
import Select from "react-select";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Image
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { ThreeDots } from 'react-loader-spinner';
import {
  getLeaveBalances,
  updateApplication,
  updateBalance,
  HRpostLeaveApplication,
  getDaysApplying,
  resetForm,
  getMedicalCert,
  addMedicalCertificate,
  updateApplicationDetails,
  updateCert,
  addSpecialAttachment,
  getSpecialAttachment,
  LeaveApplicationOverlap,
  editSpecialAttachment
} from "../../3.Store/ApplicationSlice";
import { ApprovedApplication } from "../../3.Store/ReviewLeaveApplicationSlice";
import { getListsOfLeaveWithdrawal } from "../../3.Store/LeaveWithdrawalSlice";
import { postsearchText } from "../../3.Store/EmployeeSlice";
import { openEditor } from "react-profile";
import "react-profile/themes/default";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { 
  resetClaim,
  updateMedicalClaim,
  updateAttachment,
  addMedicalClaim,
  addMedicalClaimAttachment
} from '../../3.Store/MedicalClaimSlice';
import { approveReviewMedicalClaims } from "../../3.Store/ReviewMedicalClaimsSlice";
import PDFViewer from "../../2.Commons/PDFViewer";

const HRLeaveApplicationForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [fullImage, setFullImage] = useState(null);
  const [fullImage2, setFullImage2] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const withdrawalList = useSelector(state => state.LeaveWithdrawalSlice.lists);
  const employeeName = useSelector(state => state.EmployeeSlice.supervisor);
  const employees = useSelector(state => state.EmployeeSlice.employees);

  const [employeeid, setemployeeid] = useState(null); 

  const [showBalance, setShowBalance] = useState("");
  const [isError, setIsError] = useState(false);
  const [isReasonEmpty, setReasonEmpty] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const { application, balance, applying, reason, cert, applicationDetails } = useSelector(
    (state) => state.ApplicationSlice
  );

  const {
    leave_type,
    location_type,
    reason_for_application,
    number_of_days,
    from_date,
    from_ampm,
    to_date,
    to_ampm,
    created,
    description,
    status,
    hr_remark
  } = application;
  const { reason_withdrawal } = reason;

  const role = JSON.parse(localStorage.getItem("roles"));

  //Medical Claim
  const medical_claim = useSelector(state => state.MedicalClaimSlice.medicalClaim);
  const attachment = useSelector(state => state.MedicalClaimSlice.attachment);
  const { amount, receipt_reference, receipt_no, claim_date } = medical_claim || {};

  useEffect(() => {
    if (!role || !role.includes("HR-L-APPLY")) {  // Check required role 
      localStorage.clear(); 
      window.location.href = "/Login";
    }
  
    dispatch(resetForm());
  }, []);  

  useEffect(() => {
    if (status?.description.includes("Withdrawn") && status.description.includes("Withdrawn")) {
      console.log("Status contains 'withdraw'. Perform specific actions here.");
      dispatch(getListsOfLeaveWithdrawal());

      if (withdrawalList && withdrawalList.length > 0) {
        const matchedWithdrawal = withdrawalList.find(
          (withdrawal) => withdrawal.leave_application.id === application.id
        );
        console.log(matchedWithdrawal)
        dispatch(updateApplicationDetails({ ...matchedWithdrawal }));
      }
    }
  }, [status])

  useEffect(() => {
    updateBalance(balance[leave_type]);
    showBalanceAfter();
  }, [balance, leave_type]);

  useEffect(() => {
    const appendTime = (date, ampm) => {
      return ampm === "AM" ? `${date} 08:00:00` : `${date} 13:00:00`;
    };
  
    const handleMCase = async () => {
      const fromDateString = appendTime(moment(from_date.date).format("YYYY-MM-DD"), from_ampm);
      const toDateString = appendTime(moment(to_date.date).format("YYYY-MM-DD"), to_ampm);
  
      console.log(fromDateString);
      console.log(leave_type.id);
  
      const entity = {
        ...applying,
        employee: { id: employeeid },
        from_datetime: fromDateString,
        leave_type: { id: leave_type.id },
        to_datetime: toDateString
      };
  
      console.log(entity);
  
      // Await the dispatch call to get the updated days applying
      if (employeeid !== null) {
        try {
          const updatedDaysApply = await dispatch(getDaysApplying(entity));
          console.log(updatedDaysApply);
      
          // Update the application with the correct number of days
          const days_applying = { ...application, number_of_days: updatedDaysApply.payload };
          await dispatch(updateApplication(days_applying));
        } catch (error) {
          console.error('Error updating days applying:', error);
        }
      }
      else {
        const days_applying = { ...application, number_of_days: "1.0" };
        await dispatch(updateApplication(days_applying));
      }
    };
  
    if (!from_date || !to_date) {
      return;
    };

    handleMCase();
  }, [from_date, to_date, from_ampm, to_ampm, employeeid]);

  useEffect(() => {
    if (employeeid) {  // Runs only when employeeid is set
      setLoading(true);
      dispatch(getLeaveBalances({ id: employeeid }))
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  }, [employeeid]); 

  useEffect(() => {
    if (inputValue && inputValue.length > 2) {
      const entity = { searchText: inputValue, active: 0}
      dispatch(postsearchText(entity));
    }
  }, [inputValue]);

  // Map employee names to options
  const options = employees.map(employee => ({
    label: employee.fullname,
    value: employee.fullname,
    id: employee.id
  }));

  const LeaveTypeOption = [
    { id: "A", label: "Annual Leave", value: "annual" },
    { id: "AD", label: "Advanced Leave", value: "advanced" },
    { id: "H", label: "Hospitalization", value: "hospitalization" },
    { id: "M", label: "Maternity Leave", value: "maternity" },
    { id: "P", label: "Paternity Leave", value: "paternity" },
    { id: "O", label: "Other Leave", value: "other" },
    { id: "SI", label: "Sick Leave", value: "sick" },
    { id: "SP", label: "Special Leave", value: "special" },
    { id: "UP", label: "Unpaid Leave", value: "unpaid" },
  ];

  const SpecialLeaveTypeOption = [
    {
      id: "1da74498-1637-11e9-9e53-5254006876cf",
      label: "Convocation",
      value: "co",
    },
    // {
    //   id: "287596e0-1637-11e9-9e53-5254006876cf",
    //   label: "Paternity Leave",
    //   value: "PL",
    // },
    {
      id: "093f0e92-1637-11e9-9e53-5254006876cf",
      label: "Demise of Immediate Family",
      value: "DIF",
    },
    {
      id: "0ddd720c-1637-11e9-9e53-5254006876cf",
      label: "Demise of Family",
      value: "DF",
    },
    {
      id: "185632cb-1637-11e9-9e53-5254006876cf",
      label: "Wedding",
      value: "W",
    },
  ];

  const LocationOption = [
    { id: "I", label: "In Town", value: "in_town" },
    { id: "OT", label: "Out of Town", value: "out_town" },
    { id: "W", label: "West Malaysia", value: "w_msia" },
    { id: "OS", label: "Oversea", value: "oversea" },
  ];

  const showBalanceAfter = () => {
    if (leave_type.id == "A") {
      if (employeeid === null) {
        setShowBalance("0.0");
      }
      else {
        setShowBalance(balance?.annual);
      }
    }
    if (leave_type.id == "AD") {
      setShowBalance(balance?.advanced);
    }
    if (leave_type.id == "H") {
      setShowBalance(balance?.hospitalization);
    }
    if (leave_type.id == "M") {
      setShowBalance(balance?.maternity);
    }
    if (leave_type.id == "P") {
      setShowBalance(balance?.paternity);
    }
    if (leave_type.id == "SI") {
      setShowBalance(balance?.sick);
    }
    if (leave_type.id == "SP") {
      setShowBalance(balance?.special);
    }
  };

  const handleDropdownEmployee = (selectedOption) => {
    // Find the selected option based on ID
    const selectedEmployee = options.find(option => option.id === selectedOption.id);
    
    setSelectedOption(selectedEmployee);
    console.log("Selected Employee ID:", selectedEmployee?.id);
    
    setemployeeid(selectedEmployee?.id); // This update is asynchronous
  };

  const handleChangeForm = (e) => {
    console.log(e);
    const entity = { ...application, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateApplication(entity));
    setReasonEmpty(false);
  };

  const handleChangeDropdownLeaveType = (value) => {
    if(value.id==="SP") {
      const entity = {
        ...application,
        leave_type: {
          id: value.id,
        },
        special_leave_type: {
          id: "1da74498-1637-11e9-9e53-5254006876cf"
        }
      };
      console.log(entity);
      dispatch(updateApplication(entity));
    } else {
      const entity = {
        ...application,
        leave_type: {
          id: value.id,
        }
      };
      console.log(entity);
      dispatch(updateApplication(entity));
    }
  };

  const handleChangeDropdownSpecialLeaveType = (value) => {
    console.log(value);
    const entity = {
      ...application,
      special_leave_type: {
        id: value.id,
        // description: action.label,
      },
    };
    dispatch(updateApplication(entity));
    console.log(entity);
  };

  const handleChangeFromDate = (e) => {
    console.log(e);
    const entity = { ...application, from_date: { date: e.target.value }, to_date: { date: e.target.value } };
    console.log(entity);
    dispatch(updateApplication(entity));
    setIsError(false);
  };

  const handleChangeToDate = (e) => {
    console.log(e);
    const entity = { ...application, to_date: { date: e.target.value } };
    console.log(entity);
    dispatch(updateApplication(entity));
    setIsError(false);
  };

  const handleChangeDropdownLocation = (action) => {
    console.log(action);
    const entity = {
      ...application,
      location_type: {
        id: action.id,
        // description: action.label,
      },
    };
    dispatch(updateApplication(entity));
    console.log(entity);
  }; 

  const handleBtnBack = () => {
    dispatch(resetForm());
    navigate("/");
  };

  // Function to send log to Logstash
  // const sendLogToLogstash = async (logData) => {
  //   try {
  //     await fetch("http://192.168.1.173/leave3/apiv2/public/index.php/application/module/employees/add2", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(logData),
  //     });
  //   } catch (err) {
  //     console.error("Failed to send log to Logstash:", err);
  //   }
  // };

  const handleBtnSubmit = async () => {
    if (!employeeid) {
      Swal.fire({ title: "Please select an employee", icon: "warning", confirmButtonText: "OK" });
      return;
    }
  
    if (leave_type.id === "SI") {
      if (!cert.file) {
        Swal.fire({ title: "Please upload medical certificate", icon: "warning", confirmButtonText: "OK" });
        return;
      }
  
      // if (amount <= 0) {
      //   Swal.fire({ title: "Please enter the correct claim amount", icon: "warning", confirmButtonText: "OK" });
      //   return;
      // }
  
      if (attachment.file || receipt_no !== "" || receipt_reference !== "" || amount > 0) {
        if (!attachment.file) {
          Swal.fire({ title: "Please upload the receipt attachment", icon: "warning", confirmButtonText: "OK" });
          return;
        }

        if (amount <= 0) {
          Swal.fire({ title: "Please enter the correct claim amount", icon: "warning", confirmButtonText: "OK" });
          return;
        }

        if (!receipt_no || !receipt_reference) {
          Swal.fire({ title: "Please fill in both Practitioner and Receipt No", icon: "warning", confirmButtonText: "OK" });
          return;
        }
      }
    }
  
    if (number_of_days === "0.0") {
      setIsError(true);
      Swal.fire({
        title: "Check Selected Date",
        text: "The selected date falls on a weekend or holiday. There is no need to apply for leave.",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }
  
    if (!reason_for_application.trim() || !Object.values(application).includes(reason_for_application)) {
      setReasonEmpty(true);
    } else {
      setReasonEmpty(false);
    }
  
    setLoading(true);
  
    try {
      let day_description;
      let numberofday_type;
  
      if (number_of_days !== "1.0" && number_of_days !== "0.5") {
        day_description = `${number_of_days} days leave applied on ${moment().format("YYYY-MM-DD")}, from ${from_date.date} ${from_ampm} to ${to_date.date} ${to_ampm}.`;
        numberofday_type = "M";
      } else if (number_of_days === "0.5") {
        day_description = `${number_of_days} day leave applied on ${moment().format("YYYY-MM-DD")} for ${from_date.date} ${from_ampm}.`;
        numberofday_type = "H";
      } else {
        day_description = `${number_of_days} day leave applied on ${moment().format("YYYY-MM-DD")} for ${from_date.date}.`;
        numberofday_type = "1";
      }
  
      const appendTime = (date, ampm) => ampm === "AM" ? `${date} 08:00:00` : `${date} 13:00:00`;
  
      const fromDateString = appendTime(moment(from_date.date).format("YYYY-MM-DD"), from_ampm);
      const toDateString = appendTime(moment(to_date.date).format("YYYY-MM-DD"), to_ampm);
  
      const overlapResponse = await dispatch(LeaveApplicationOverlap({
        edatetime: toDateString,
        employee: { id: employeeid },
        sdatetime: fromDateString
      })).unwrap();
  
      if (overlapResponse !== "0.0") {
        setLoading(false);
        Swal.fire("", "This leave application OVERLAPS with one or more existing leave applications.", "warning", "OK");
        return;
      }
  
      const entity = {
        ...application,
        description: day_description,
        numberofday_type: { id: numberofday_type },
        employee_id: employeeid,
      };
  
      const response = await dispatch(HRpostLeaveApplication(entity)).unwrap();
      const applicationId = response.id;
  
      if (leave_type.id === "SI") {
        const entity2 = { ...cert, leave_application: { id: applicationId } };
        await dispatch(addMedicalCertificate(entity2));

        //Medical Claim
        if (attachment.file || receipt_no !== "" || receipt_reference !== "" || amount > 0) {
          const mc = { ...medical_claim, id: employeeid, leave_application: { id: applicationId } }

          const addedClaim = await dispatch(addMedicalClaim(mc)).unwrap();
          const claimId = addedClaim.id;
    
          const entityAttach = { ...attachment, id: { id: claimId } };
          await dispatch(addMedicalClaimAttachment(entityAttach));
          // await dispatch(approveReviewMedicalClaims([claimId]));
        }
      } else if (leave_type.id === "SP") {
        const entity3 = { ...cert, leave_application: { id: applicationId } };
        await dispatch(addSpecialAttachment(entity3));
      }
  
      await dispatch(ApprovedApplication({ id: applicationId, hr_remark: hr_remark }));
  
      // sendLogToLogstash({
      //   level: "info",
      //   message: "Leave application created successfully",
      //   timestamp: new Date().toISOString(),
      //   app: "LeaveApplicationSystem",
      //   data: { ...entity },
      // });
  
      setLoading(false);
      Swal.fire("Leave Application Created", "", "success", "OK").then(() => {
        dispatch(resetForm());
        if (role?.includes("HR-L-APPROVAL")) {
          navigate("/ReviewLeaveList");
        } else {
          window.location.reload();
        }
      });
    } catch (err) {
      // sendLogToLogstash({
      //   level: "error",
      //   message: "Submission failed",
      //   timestamp: new Date().toISOString(),
      //   app: "LeaveApplicationSystem",
      //   error: err.response?.data || err.message,
      // });
  
      setLoading(false);
      Swal.fire("Error / Masalah", err.response?.data || "An unexpected error occurred.", "error", "OK");
    }
  };  

  const handleAttachmentChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

    if (!allowedTypes.includes(selectedFile.type)) {
      Swal.fire({
        text: "Only JPG, PNG, or PDF files are allowed. / Hanya fail JPG, PNG atau PDF dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK"
      });
  
      event.target.value = null;
  
      const entity = {
        ...cert,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateCert(entity));
      return;
    }

    setLoading(true); // Adjust this if you're using a different loading state

    const reader = new FileReader();

    reader.onloadend = () => {
      const fileResult = reader.result;
  
      if (selectedFile.type === 'application/pdf') {
        const base64String = fileResult.split(',')[1];
        finishUpload(base64String);
      } else {
        setFullImage(fileResult);
        setLoading(false);
  
        openEditor({ src: selectedFile })
          .then(editor => {
            const base64String = editor?.editedImage?.getDataURL();
            if (!base64String) {
              setLoading(false);
              return;
            }
            finishUpload(base64String);
          })
          .catch(error => {
            console.error("Editor error:", error);
            Swal.fire({
              text: "There was an error editing the image.",
              icon: "error",
              confirmButtonText: "OK"
            });
            setLoading(false);
          });
      }
    };

    reader.onerror = () => {
      Swal.fire({
        text: "Error reading file.",
        icon: "error",
        confirmButtonText: "OK"
      });
      setLoading(false);
    };

    reader.readAsDataURL(selectedFile);

    function finishUpload(base64String) {
      const entity = {
        ...cert,
        file: base64String,
        filename: selectedFile.name,
        filetype: selectedFile.type,
        filesize: selectedFile.size
      };

      dispatch(updateCert(entity));
      console.log("Base64 File:", base64String);
      console.log("Filename:", selectedFile.name);
      console.log("Filetype:", selectedFile.type);
      console.log("Filesize:", selectedFile.size, "bytes");

      setTimeout(() => {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }, 500);
    }
  };

  const handleEditImage = async () => {
    if (fullImage) {
      try {
        const editor = await openEditor({ src: fullImage });

        if (editor && editor.editedImage) {
          const updatedImage = editor.editedImage.getDataURL();
          const entity = { ...cert, file: updatedImage };
          dispatch(updateCert(entity));
        } else {
          console.error("Edited image not found.");
        }
      } catch (error) {
        console.error("Error opening editor:", error);
      }
    } else {
      console.error("Full image is not set.");
    }
  };

  const handleEditImage2 = async () => {
    if (fullImage2) {
      try {
        const editor = await openEditor({ src: fullImage2 });

        if (editor && editor.editedImage) {
          const updatedImage = editor.editedImage.getDataURL();
          const entity = { ...attachment, file: updatedImage };
          dispatch(updateAttachment(entity));
        } else {
          console.error("Edited image not found.");
        }
      } catch (error) {
        console.error("Error opening editor:", error);
      }
    } else {
      console.error("Full image is not set.");
    }
  };

  //Medical Claim
  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

    if (!allowedTypes.includes(selectedFile.type)) {
      Swal.fire({
        text: "Only JPG, PNG, or PDF files are allowed. / Hanya fail JPG, PNG atau PDF dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK"
      });

      event.target.value = null;

      const entity = {
        ...attachment,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateAttachment(entity));
      return;
    }

    setLoading(true);

    try {
      const fileResult = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(selectedFile);
      });

      let base64String;

      if (selectedFile.type === 'application/pdf') {
        base64String = fileResult.split(',')[1];
      } else {
        setFullImage2(fileResult);
        setLoading(false);
        const editor = await openEditor({ src: selectedFile });

        if (!editor?.editedImage) {
          throw new Error("Failed to get edited image.");
        }

        base64String = editor.editedImage.getDataURL();
      }

      const entity = {
        ...attachment,
        file: base64String,
        filename: selectedFile.name,
        filetype: selectedFile.type,
        filesize: selectedFile.size
      };

      dispatch(updateAttachment(entity));

      console.log("Base64 File:", base64String);
      console.log("Filename:", selectedFile.name);
      console.log("Filetype:", selectedFile.type);
      console.log("Filesize:", selectedFile.size, "bytes");

      // Simulate a short delay like original `setTimeout`
      await new Promise((res) => setTimeout(res, 1000));

    } catch (error) {
      console.error("Attachment error:", error);

      Swal.fire({
        text: error.message.includes("edited image")
          ? "There was an error editing the image."
          : "Error reading file.",
        icon: "error",
        confirmButtonText: "OK"
      });

      const entity = {
        ...attachment,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateAttachment(entity));
    } finally {
      setLoading(false);
    }
  }; 

  const handleFormChange = (e) => {
    const entity = { ...medical_claim, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateMedicalClaim(entity));
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">HR Leave Application</h1>

        <Row className="my-3">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fs-5">Employee Name</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Select
              inputValue={inputValue}
              onInputChange={(value) => setInputValue(value)}
              name="name"
              onChange={handleDropdownEmployee}
              options={options}
              value={selectedOption}
              placeholder="Select Employee"

              /* 👇 ADD THESE - avoid covered by the PDF viewer */
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fs-5">Leave Type</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Select
              name="leave_type"
              options={LeaveTypeOption}
              value={LeaveTypeOption.find(
                (option) => option.id === leave_type.id
              )}
              onChange={handleChangeDropdownLeaveType}

              /* 👇 ADD THESE - avoid covered by the PDF viewer */
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </Col>
        </Row>

        {/* Leave Available */}
        {leave_type?.id !== "O" && leave_type?.id !== "UP" && leave_type?.id !== "AD" && (
          <Row className="my-2">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fs-5">Leave Available</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              <Form.Control readOnly disabled value={showBalance || "0.0"} />
            </Col>
          </Row>
        )}

        {/* Leave Advanced */}
        {leave_type?.id == "AD" && (
          <Row className="my-2">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fs-5">Leave Advanced</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              <Form.Control readOnly disabled value={showBalance} />
            </Col>
          </Row>
        )}

        {leave_type?.id == "SI" && (
          <Row className="my-2">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fs-5">Medical Certificate</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              <Form.Control type="file" onChange={handleAttachmentChange}/>
            </Col>
          </Row>
        )}

        {/* Special Leave */}
        {leave_type?.id === "SP" && (
          <>
            <Row className="my-2">
              <Col md={8} sm={8}>
                <Form.Label className="FormLabel fs-5">
                  Special Leave Type
                </Form.Label>
              </Col>
              <Col md={4} sm={4}>
                <Select
                  name="special_leave_type"
                  options={SpecialLeaveTypeOption}
                  onChange={handleChangeDropdownSpecialLeaveType}

                  /* 👇 ADD THESE - avoid covered by the PDF viewer */
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        {leave_type?.id == "SP" && (
          <Row className="my-2">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fs-5">Attachment</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              <Form.Control type="file" onChange={handleAttachmentChange} />
            </Col>
          </Row>
        )}

        {/* Conditional rendering based on attachment existence */}
        {cert && cert.file && (leave_type?.id === "SI" || leave_type?.id === "SP") && (
          <Row className="my-3">
            <Col
              md={12}
              sm={12}
              className="d-flex justify-content-center align-items-center"
            >
              {cert.filetype.startsWith("image/") ? (
                // 📷 Display image
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    backgroundColor: "#373c40",
                    height: "500px",
                    width: "100%",
                    overflow: "auto",
                  }}
                >
                  <Image
                    src={cert.file}
                    alt="Uploaded file"
                    fluid
                    style={{ maxWidth: "100%", height: "100%" }}
                    onClick={handleEditImage}
                  />
                </div>
              ) : (
                // 📄 Display PDF (base64 → Blob → ObjectURL for Chrome)
                cert.file ? (
                  <div style={{ width: "100%" }}>
                    <PDFViewer base64Data={cert.file} height="500px" width="100%" />
                  </div>
                ) : (
                  <a href={`data:application/pdf;base64,${cert.file}`} download="attachment.pdf">
                    Download PDF
                  </a>
                )
              )}
            </Col>
          </Row>
        )}

        <Row className="my-2">
          <Col md={6} sm={4}>
            <Form.Label className="FormLabel fs-5">From</Form.Label>
          </Col>
          <Col md={2} sm={4}>
            <div>
              <Form.Check
                type="radio"
                label="AM"
                name="from_ampm"
                value="AM"
                style={{ color: "#fff" }}
                checked={from_ampm === "AM"}
                onChange={handleChangeForm}
              />
              <Form.Check
                type="radio"
                label="PM"
                name="from_ampm"
                value="PM"
                style={{ color: "#fff" }}
                checked={from_ampm === "PM"}
                onChange={handleChangeForm}
              />
            </div>
          </Col>
          <Col md={4} sm={4}>
            {/* <Form.Control
              type="date"
              name="from_date"
              value={moment(from_date?.date).format("YYYY-MM-DD")}
              onChange={handleChangeFromDate}
              style={{
                border: isError ? "3px solid red" : "",
                borderRadius: "5px"
              }}
            /> */}
            <DatePicker
              selected={from_date?.date ? new Date(from_date?.date) : null}
              onChange={(date) =>
                handleChangeFromDate({
                  target: {
                    name: "from_date",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              dateFormat="yyyy-MM-dd"
              className={`form-control w-100 datepicker-icon ${isError ? 'error-border' : ''}`}
            />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={6} sm={4}>
            <Form.Label className="FormLabel fs-5">To</Form.Label>
          </Col>
          <Col md={2} sm={4}>
            <div>
              <Form.Check
                type="radio"
                label="AM"
                name="to_ampm"
                value="AM"
                style={{ color: "#fff" }}
                checked={to_ampm === "AM"}
                onChange={handleChangeForm}
              />
              <Form.Check
                type="radio"
                label="PM"
                name="to_ampm"
                value="PM"
                style={{ color: "#fff" }}
                checked={to_ampm === "PM"}
                onChange={handleChangeForm}
              />
            </div>
          </Col>
          <Col md={4} sm={4}>
            {/* <Form.Control
              type="date"
              name="to_date"
              value={moment(to_date?.date).format("YYYY-MM-DD")}
              onChange={handleChangeToDate}
              min={moment(from_date?.date).format("YYYY-MM-DD")}
              style={{
                border: isError ? "3px solid red" : "",
                borderRadius: "5px"
              }}
            /> */}
            <DatePicker
              selected={to_date?.date ? new Date(to_date?.date) : null}
              onChange={(date) =>
                handleChangeToDate({
                  target: {
                    name: "to_date",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              dateFormat="yyyy-MM-dd"
              className={`form-control w-100 datepicker-icon ${isError ? 'error-border' : ''}`}
            />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fs-5">Location</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Select
              name="location_type"
              options={LocationOption}
              value={LocationOption.find(
                (option) => option.id === location_type.id
              )} // Correctly set the value to match the selected option
              onChange={handleChangeDropdownLocation}
            />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fs-5">No. Days Applying</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Form.Control readOnly disabled value={number_of_days} />
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fs-5">Reason</Form.Label>
            <Form.Control 
              as="textarea"
              name="reason_for_application"
              value={reason_for_application}
              onChange={handleChangeForm}
              style={{
                border: isReasonEmpty ? "3px solid red" : "",
                borderRadius: "5px"
              }}
            />
          </Col>
        </Row>

        {/* <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fs-5">HR Remark</Form.Label>
            <Form.Control 
              as="textarea"
              name="hr_remark"
              value={hr_remark}
              onChange={handleChangeForm}
              style={{
                border: isReasonEmpty ? "3px solid red" : "",
                borderRadius: "5px"
              }}
            />
          </Col>
        </Row> */}

        {leave_type?.id === "SI" && (role || role.includes("HR-M-APPLY")) && (
          <>
            <hr className="hr-white" />

            <h1 className="TitleHeader">HR Medical Claim Application (Optional)</h1>

            <Row className="my-3">
              <Col md={6} sm={6}>
                <Form.Label className="FormLabel fs-5">Invoice Date</Form.Label>
              </Col>
              <Col md={6} sm={6}>
                <DatePicker
                  selected={claim_date ? new Date(claim_date) : null}
                  onChange={(date) =>
                    handleFormChange({
                    target: {
                        name: "claim_date",
                        value: moment(date).format("YYYY-MM-DD"),
                    },
                    })
                  }
                  dateFormat="yyyy-MM-dd"
                  className="form-control w-100 datepicker-icon"
                />
                {/* <Form.Control type="date" name="claim_date" value={moment(claim_date).format("YYYY-MM-DD")} onChange={handleFormChange}/> */}
              </Col>
            </Row>

            <Row className="my-3">
              <Col md={6} sm={6}>
                <Form.Label className="FormLabel fs-5">Practitioner</Form.Label>
              </Col>
              <Col md={6} sm={6}>
                <Form.Control name="receipt_no" value={receipt_no} onChange={handleFormChange} placeholder="Enter Practitioner"/>
              </Col>
            </Row>

            <Row className="my-3">
              <Col md={6} sm={6}>
                <Form.Label className="FormLabel fs-5">
                  Claim (RM) Balance RM{balance?.medical_benefit || 0}
                </Form.Label>
              </Col>
              <Col md={6} sm={6}>
                <Form.Control name="amount" value={amount} onChange={handleFormChange}/>
              </Col>
            </Row>

            <Row className="my-3">
              <Col md={6} sm={6}>
                <Form.Label className="FormLabel fs-5">Receipt No</Form.Label>
              </Col>
              <Col md={6} sm={6}>
                <Form.Control name="receipt_reference" value={receipt_reference} onChange={handleFormChange} placeholder="Enter Receipt No"/>
              </Col>
            </Row>

            <Row className="my-3">
              <Col md={12} sm={12}>
                <Form.Control type="file" onChange={handleFileChange} />
              </Col>
            </Row>

            {/* Conditional rendering based on attachment existence */}
            {attachment && attachment.file && (
              <Row className="my-3">
                <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
                  {/* Display image */}
                  {attachment.filetype.startsWith("image/") ? (
                    // 📷 Display image
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                        backgroundColor: "#373c40",
                        height: "500px",
                        width: "100%",
                        overflow: "auto",
                      }}
                    >
                      <Image
                        src={attachment.file}
                        alt="Uploaded file"
                        fluid
                        style={{ maxWidth: "100%", height: "100%" }}
                        onClick={handleEditImage2}
                      />
                    </div>
                  ) : (
                    // 📄 Display PDF (base64 → Blob → ObjectURL for Chrome)
                    attachment.file ? (
                      <div style={{ width: "100%" }}>
                        <PDFViewer base64Data={attachment.file} height="500px" width="100%" />
                      </div>
                    ) : (
                      <a href={`data:application/pdf;base64,${attachment.file}`} download="attachment.pdf">
                        Download PDF
                      </a>
                    )
                  )}
                </Col>
              </Row>
            )}
          </>
        )}

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnSubmit}>
              Submit
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};
export default HRLeaveApplicationForm;